import React, { useEffect, useState } from 'react';

const LOADER_TIMEOUT = 500;

const Preloader = () => {
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setIsLoading(true);

		const timer = setTimeout(() => {
			setIsLoading(false);
		}, LOADER_TIMEOUT);

		return () => clearTimeout(timer); // Cleanup for safety
	}, []);

	if (!isLoading) {
		return null;
	}

	return (
		<div className="preloader">
			<div className="preloader__spinner lds-ellipsis">
				<div />
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};

export default React.memo(Preloader);
